import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { FormattedMessage } from 'react-intl';
import Typography from '../Typography';
import warningIcon from './warningIcon.svg';

function UnavailableVideoPlaceholder({ classes }) {
  return (
    <div className={classes.wrapper}>
      <img src={warningIcon} alt="" className={classes.warningIcon} />
      <div className={classes.messagesWrapper}>
        <Typography className={classes.title} type="title">
          <FormattedMessage id="unavailableVideoTitle" />
        </Typography>
        <Typography type="body1">
          <FormattedMessage id="unavailableVideoDescription" />
        </Typography>
      </div>
    </div>
  );
}

UnavailableVideoPlaceholder.propTypes = {
  classes: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  wrapper: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.grey.faintBlack,
    border: theme.border.medium,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  messagesWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  warningIcon: {
    width: '36px',
    margin: [0, theme.spacing.small],
  },
  title: {
    marginBottom: theme.spacing.unit,
    fontWeight: 'bold',
  },
});

export default injectSheet(stylesheet)(UnavailableVideoPlaceholder);



// WEBPACK FOOTER //
// ./src/site-render/src/HighlightSection/UnavailableVideoPlaceholder.js